/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const WhatsNewIntro = styled.p({
  whiteSpace: 'normal',
  marginTop: 0,
  paddingTop: '6px',
  color: token('color.text.subtle'),
  font: token('font.body.UNSAFE_small'),
  marginBottom: token('space.100'),
});

export const Card = styled.div({
  backgroundColor: token('color.background.accent.gray.subtlest'),
  padding: token('space.100'),
  margin: token('space.100'),
  // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
  borderRadius: token('radius.small', '3px'),
});

export const CardHeader = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const Date = styled.span({
  font: token('font.body.UNSAFE_small'),
  color: token('color.text.accent.gray'),
});

export const CardInner = styled.div({
  padding: token('space.100'),
  backgroundColor: token('elevation.surface'),
  // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
  borderRadius: token('radius.small', '3px'),
  marginTop: token('space.100'),
  boxShadow: `0 0 1px 0 ${token('color.blanket')}`,
});

export const CardTitle = styled.span({
  font: token('font.body.large'),
  color: token('color.text'),
});

export const LearnMoreLink = styled.a({
  color: token('color.link'),
  font: token('font.body.UNSAFE_small'),
});
